import axios from "axios";
import baseApi from "./baseApi";
import "./baseApi";

const getServices = () => axios.get(`Service/Services`, { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });
const getServiceList = () => axios.get(`Service/ServiceList`, { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });

export default {
    getServices,
    getServiceList
};